import React from 'react';
import type { Vod } from '../api/types';
import { STUDIO_COPY } from '../config';
import { formatDuration, formatVodDate } from '../utils/format';
import { isReelEligibleVod } from '../utils/vodEligibility';
import StudioVodExpiry from './StudioVodExpiry';

type VodCardProps = {
  vod: Vod;
  selected: boolean;
  onSelect: (vod: Vod) => void;
};

const VodCard: React.FC<VodCardProps> = ({ vod, selected, onSelect }) => {
  const eligible = isReelEligibleVod(vod);
  const tooShortHint = STUDIO_COPY.vodTooShortHint;

  return (
    <button
      type="button"
      className={`studio-vod-card ${selected ? 'is-selected' : ''} ${
        eligible ? '' : 'is-too-short'
      }`}
      onClick={() => {
        if (!eligible) return;
        onSelect(vod);
      }}
      disabled={!eligible}
      aria-disabled={!eligible}
      aria-pressed={eligible ? selected : undefined}
      title={eligible ? undefined : tooShortHint}
      data-testid={`studio-vod-card-${vod.vod_id}`}
      data-eligible={eligible ? 'true' : 'false'}
    >
      <div className="aspect-video bg-black/40 relative overflow-hidden">
        <img
          src={vod.thumbnail_url}
          alt=""
          className={`w-full h-full object-cover ${eligible ? 'opacity-90' : 'opacity-40'}`}
          loading="lazy"
        />
        <span className="absolute bottom-2 right-2 text-xs font-medium bg-black/75 text-white px-1.5 py-0.5 rounded">
          {formatDuration(vod.duration_sec)}
        </span>
        {!eligible ? (
          <span
            className="absolute top-2 left-2 text-[10px] font-semibold uppercase tracking-wide bg-black/80 text-[var(--studio-muted)] px-1.5 py-0.5 rounded"
            data-testid={`studio-vod-too-short-${vod.vod_id}`}
          >
            {tooShortHint}
          </span>
        ) : null}
      </div>
      <div className="p-3 space-y-1">
        <p className="text-sm font-medium text-[var(--studio-text)] line-clamp-2 text-left">
          {vod.title}
        </p>
        <p className="text-xs text-[var(--studio-muted)] text-left">
          {formatVodDate(vod.created_at)}
        </p>
        <StudioVodExpiry vod={vod} className="text-left" />
      </div>
    </button>
  );
};

export default VodCard;
